(() => {
  const normalise = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const initFaqSearch = () => {
    const input = document.querySelector('[data-rmx-faq-search]');
    const faq = document.querySelector('body:has(.rmx-faq-v6-tools) .cc-faq');
    if (!input || !faq || input.dataset.rmxReady === 'true') return;

    input.dataset.rmxReady = 'true';
    const empty = document.querySelector('[data-rmx-faq-empty]');
    const questions = Array.from(faq.querySelectorAll('details-disclosure'));
    const categories = Array.from(faq.querySelectorAll('h3'));

    const updateCategories = () => {
      categories.forEach((category) => {
        let next = category.nextElementSibling;
        let hasVisibleQuestion = false;

        while (next && next.tagName !== 'H3') {
          if (next.matches('details-disclosure') && !next.hasAttribute('data-rmx-hidden')) {
            hasVisibleQuestion = true;
            break;
          }
          next = next.nextElementSibling;
        }

        category.toggleAttribute('data-rmx-hidden', !hasVisibleQuestion);
      });
    };

    const filter = () => {
      const query = normalise(input.value);
      let visible = 0;

      questions.forEach((item) => {
        const matches = !query || normalise(item.textContent).includes(query);
        item.toggleAttribute('data-rmx-hidden', !matches);
        if (matches) visible += 1;
      });

      updateCategories();
      if (empty) empty.hidden = visible > 0;
    };

    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
  };

  const init = () => initFaqSearch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
